import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import '../App.css';

function NashaMuktiKendraPatna() {
  useEffect(() => {
    const handleScroll = () => {
      document.querySelectorAll('.animate-on-scroll').forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight - 150) {
          el.classList.add('animate');
        }
      });
    };
    setTimeout(handleScroll, 100);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <SEO
        title="Nasha Mukti Kendra in Patna | नशा मुक्ति केंद्र पटना | Nihansh Foundation"
        description="पटना में नशा मुक्ति केंद्र: निहांश फाउंडेशन — 24×7 मेडिकल, काउंसलिंग, पुनर्वास। शराब, ड्रग्स और अन्य नशों की लत से मुक्ति। कॉल +91 6202410010"
        path="/nasha-mukti-kendra-in-patna"
      />
      <section
        className="page-hero about-hero"
        style={{
          backgroundImage: 'url(/images/Cigarette addiction.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
        }}
      >
        <div className="page-hero-background">
          <div className="page-hero-overlay"></div>
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">Nasha Mukti Kendra in Patna</h1>
          <p className="page-hero-subtitle">पटना में नशा मुक्ति केंद्र — निहांश फाउंडेशन के साथ सुरक्षित इलाज</p>
        </div>
      </section>

      <section className="about">
        <div className="container">
          <div className="local-seo-page-content animate-on-scroll">
            <p className="local-seo-lead">
              <strong>Nasha Mukti Kendra in Patna</strong> ढूँढ रहे परिवारों के लिए निहांश फाउंडेशन एक पूर्ण सेवा केंद्र है जहाँ शराब, ड्रग्स, इंजेक्शन, गांजा, ब्राउन शुगर, स्मैक और सॉल्वेंट जैसे सभी प्रकार के नशों का{' '}
              <strong>medical detox</strong>, <strong>counselling</strong> और <strong>rehabilitation</strong> मिलता है।
            </p>

            <h2 className="local-seo-h2">पटना में नशा मुक्ति केंद्र क्यों ज़रूरी है?</h2>
            <p>
              नशा केवल व्यक्ति को नहीं, पूरे परिवार को प्रभावित करता है। घर पर अकेले नशा छोड़ने से कई बार खतरनाक withdrawal symptoms हो सकते हैं। एक भरोसेमंद{' '}
              <strong>nasha mukti kendra in Patna</strong> में 24×7 डॉक्टर की निगरानी, संरचित दिनचर्या और पारिवारिक परामर्श मिलता है।
            </p>

            <h2 className="local-seo-h2">निहांश फाउंडेशन में क्या मिलता है?</h2>
            <ul className="local-seo-list">
              <li>चिकित्सकीय विषहरण (detox) और इमरजेंसी सपोर्ट</li>
              <li>व्यक्तिगत व समूह काउंसलिंग, फैमिली थेरेपी</li>
              <li>योग, ध्यान और रिलैप्स रोकथाम कार्यक्रम</li>
              <li>सुरक्षित, गोपनीय वातावरण — पटना में पिकअप सुविधा उपलब्ध</li>
            </ul>

            <p>
              अगर आप <strong>best nasha mukti kendra in Patna</strong> की तुलना कर रहे हैं, तो{' '}
              <Link to="/best-nasha-mukti-kendra-in-patna">यह पेज ज़रूर पढ़ें</Link> — जहाँ हमने बताया है कि सही केंद्र कैसे चुनें और निहांश फाउंडेशन क्यों भरोसेमंद है।
            </p>

            <div className="local-seo-cta">
              <a href="tel:+916202410010" className="cta-button primary">📞 +91 6202410010</a>
              <Link to="/contact" className="cta-button secondary">संपर्क व पता</Link>
              <Link to="/blog" className="cta-button secondary">ब्लॉग पढ़ें</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default NashaMuktiKendraPatna;
